import { render, staticRenderFns } from "./older_list.vue?vue&type=template&id=6c7e0e1c&scoped=true&"
import script from "./older_list.vue?vue&type=script&lang=js&"
export * from "./older_list.vue?vue&type=script&lang=js&"
import style0 from "./older_list.vue?vue&type=style&index=0&id=6c7e0e1c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e0e1c",
  null
  
)

export default component.exports